import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  const r = e?.response;
  if (!r) return "Can't reach the Hub server — check your internet connection and try again.";
  const d = r.data?.detail;
  const detail = d != null && r.status !== 500 ? formatApiErrorDetail(d) : null;
  if (r.status === 401) return "Your session expired — sign in again.";
  if (r.status === 403) return detail && !/not authenticated|forbidden/i.test(detail) ? detail : "Your account doesn't have access to this.";
  if ([502, 503, 504].includes(r.status)) return detail || "A connected service didn't respond — try again in a minute.";
  if (r.status >= 500) return "Something broke on our side — try again. If it keeps happening, let the Hub admin know.";
  return detail || "Something went wrong. Please try again.";
}

api.interceptors.response.use(undefined, (e) => { if (e && typeof e === "object") e.userMessage = errMsg(e); return Promise.reject(e); });

export async function downloadDocument(doc) {
  const res = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = doc.original_filename || doc.label || "document";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default api;
